import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Feather } from '@expo/vector-icons';
import THEME from '../../../config/theme';
import { useCustomTheme } from '../../../contexts/useCustomTheme';

const ChannelManager = ({ onPress }) => {
  const { customColor } = useCustomTheme();

  return (
    <TouchableOpacity onPress={onPress} style={{ marginRight: 12 }}>
      <Feather
        name="settings"
        size={22}
        color={
          customColor && customColor.text && customColor.text.app
            ? customColor.text.app
            : THEME.COLORS.TEXT_MAIN
        }
      />
    </TouchableOpacity>
  );
};

export default ChannelManager;
